import { render, staticRenderFns } from "./QuickTipsPersonIdConfiguration.vue?vue&type=template&id=522f05dc&scoped=true&"
import script from "./QuickTipsPersonIdConfiguration.vue?vue&type=script&lang=js&"
export * from "./QuickTipsPersonIdConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f05dc",
  null
  
)

export default component.exports